import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=37072a4b&scoped=true&"
import script from "./SettingsComponent.vue?vue&type=script&lang=js&"
export * from "./SettingsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SettingsComponent.vue?vue&type=style&index=1&id=37072a4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37072a4b",
  null
  
)

export default component.exports